/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  Crops,
  Crops_crops_Crops_results_Crop as Crop,
  CropsVariables,
} from './types/crops.graphql'

export const CROPS = gql`
  query Crops($all: Boolean) {
    crops(all: $all) {
      results {
        id
        name
        cropType
        locales {
          es
          en
          pt
        }
      }
    }
  }
`
